'use client';

import * as React from 'react';
import ErrorPage from '@/components/ui/ErrorPage';
import ErrorPagePromotion from '@/components/ui/ErrorPagePromotion';
import Body from '@/components/ui/Body';

const NotFound: React.FunctionComponent = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'https://www.luckyblock.com/';

  return (
    <div id="__next">
      <Body>
        <ErrorPage
          title={
            <React.Fragment>
              Where <b>Lambo?</b>
            </React.Fragment>
          }
          subTitle="Page not found."
          description="It may have been removed or is not available right now."
          imageMobile="/images/jackpot/error-404-mobile.jpg"
          imageTablet="/images/jackpot/error-404-tablet.jpg"
          imageDesktop="/images/jackpot/error-404-desktop.jpg"
          slotAddOn={
            <ErrorPagePromotion
              title="Lambo is here"
              timeLeft="210 days"
              description="Lamborghini pool"
              poolSize="$300k USDT"
              buttonTitle="To the jackpots!"
              buttonHref={`https://${hostname}`}
              imageSrc="/images/jackpot/lambo-pool.png"
            />
          }
        />
      </Body>
    </div>
  );
};

NotFound.displayName = 'NotFound';

export default NotFound;
